import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
  createComponentExtension,
} from '@backstage/core-plugin-api';
import { DevOpsMetricsClient, devOpsMetricsApiRef } from './api';

/** @public */
export const devOpsMetricsPlugin = createPlugin({
  id: 'devops-metrics',
  apis: [
    createApiFactory({
      api: devOpsMetricsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new DevOpsMetricsClient({
          discoveryApi,
          identityApi,
        }),
    }),
  ],
});

/** @public */
export const DevOpsMetricsPage = devOpsMetricsPlugin.provide(
  createComponentExtension({
    name: 'DevOpsMetricsPage',
    component: {
      lazy: () =>
        import('./components/DevOpsMetricsComponent').then(m => m.DevOpsMetricsComponent),
    },
  }),
);